export enum ImageTypeDTO {
  IMAGE_DISPLAY_NORMAL = 'IMAGE_DISPLAY_NORMAL',
  PAGER = 'PAGER',
  ANNOUNCEMENT_IMAGE = 'ANNOUNCEMENT_IMAGE',
  DYNAMIC_TIMETABLE_BACKGROUND = 'DYNAMIC_TIMETABLE_BACKGROUND',
  STATIC_TIMETABLE = 'STATIC_TIMETABLE',
  GENERAL_BACKGROUND = 'GENERAL_BACKGROUND',
}
